var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 214,
    viewBox: "0 0 210 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.519 71.7895C102.34 71.0834 100.423 67.9058 101.18 64.7282C102.977 57.4108 106.482 43.9942 111.047 29.6837C112.406 25.4232 117.04 23.1906 121.251 24.6969C125.371 26.1708 127.554 30.6837 125.952 34.7558C120.633 48.2754 114.236 60.3181 112.482 67.5023C111.675 70.6295 108.597 72.4957 105.519 71.7895Z",
    fill: "url(#paint0_radial_1099_57878)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.138 64.9149C101.772 65.394 102.517 65.7482 103.349 65.933C106.427 66.6391 109.505 64.7729 110.312 61.6458C111.343 57.4248 113.976 51.5267 117.052 44.6373C119.211 39.8008 121.588 34.4756 123.782 28.8992C124.074 28.1572 124.241 27.4006 124.292 26.6504C126.317 28.7406 127.091 31.8592 125.952 34.7549C123.758 40.3313 121.381 45.6564 119.221 50.493C116.146 57.3824 113.512 63.2804 112.482 67.5014C111.675 70.6286 108.597 72.4948 105.519 71.7886C102.403 71.0964 100.499 68.029 101.138 64.9149Z",
    fill: "url(#paint1_radial_1099_57878)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.103 61.2613C148.9 54.8937 137.112 57.2358 125.47 60.8954C118.88 62.9447 110.899 65.8724 104.09 63.2375C100.355 61.7737 98.5981 58.6996 95.889 56.0647C93.3996 53.5762 90.4708 51.3805 87.4688 49.5507C76.1198 42.2316 62.2813 39.5235 49.0285 41.7192C35.9955 43.8418 21.3516 51.3805 13.9564 62.5788C5.46294 75.4604 1.21621 90.7575 0.264356 106.054C-0.907156 123.328 1.9484 140.674 6.19514 157.435C7.87918 164.168 9.85611 170.902 13.0045 177.05C23.3285 197.397 47.4909 206.839 69.3103 202.301C85.2722 199.008 100.722 209.767 116.024 212.402C119.612 212.987 123.639 213.426 127.227 213.06C131.034 212.694 134.329 210.133 137.404 207.864C144.58 202.667 150.73 196.153 156.002 189.054C175.625 162.778 193.344 124.938 183.02 91.6357C179.359 79.9251 171.085 67.4826 160.103 61.2613Z",
    fill: "url(#paint2_radial_1099_57878)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43262 133.699C2.42469 136.52 3.56403 139.278 4.92098 141.928C15.2449 162.275 39.4074 171.717 61.2268 167.179C71.4141 165.077 81.3926 168.699 91.2575 172.28C96.8493 174.31 102.405 176.326 107.941 177.279C111.529 177.865 115.556 178.304 119.143 177.938C122.768 177.59 125.927 175.252 128.875 173.071C129.024 172.961 129.173 172.851 129.321 172.742C136.496 167.545 142.647 161.031 147.919 153.931C163.031 133.695 177.014 106.601 177.928 80.002C180.086 83.7913 181.807 87.7535 183.02 91.6353C193.344 124.937 175.625 162.777 156.002 189.053C150.73 196.153 144.58 202.667 137.404 207.863C137.256 207.973 137.108 208.082 136.959 208.193C134.011 210.374 130.851 212.712 127.227 213.06C123.639 213.426 119.612 212.987 116.024 212.401C110.488 211.448 104.933 209.431 99.3409 207.402C89.476 203.821 79.4975 200.199 69.3102 202.301C47.4907 206.839 23.3283 197.397 13.0044 177.05C9.85592 170.902 7.87899 164.168 6.19494 157.434C4.2169 149.628 2.54067 141.694 1.43262 133.699Z",
    fill: "url(#paint3_linear_1099_57878)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9023 76.0262C67.9023 88.5852 51.7056 106.289 39.1418 106.289C26.578 106.289 20.4727 92.1158 20.4727 79.5568C20.4727 66.9978 34.1465 56.3555 46.7104 56.3555C59.2742 56.3555 67.9023 63.4672 67.9023 76.0262Z",
    fill: "url(#paint4_radial_1099_57878)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4713 192.156C94.9009 196.529 89.7545 192.795 80.8567 191.635C71.9589 190.475 62.6791 192.33 63.2495 187.957C63.8199 183.583 71.4228 179.492 80.3206 180.651C89.2184 181.811 96.0417 187.782 95.4713 192.156Z",
    fill: "url(#paint5_linear_1099_57878)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5936 187.392C88.2851 189.758 85.5009 187.737 80.6873 187.11C75.8737 186.483 70.8535 187.486 71.1621 185.12C71.4707 182.754 75.5837 180.541 80.3973 181.168C85.2109 181.796 88.9022 185.026 88.5936 187.392Z",
    fill: "url(#paint6_linear_1099_57878)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7657 113.663C85.4004 113.337 83.6592 115.794 84.6979 117.928C85.8727 120.312 88.1573 122.098 91.0162 122.485C93.8422 122.868 96.5473 121.8 98.3302 119.815C99.9199 118.04 98.8681 115.203 96.5357 114.881C96.5357 114.881 93.2085 115.038 92.1267 114.871C90.979 114.695 87.7657 113.663 87.7657 113.663Z",
    fill: "#661A39"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2543 119.9C97.0328 118.705 95.4308 117.876 93.591 117.627C90.8048 117.249 88.1362 118.282 86.3533 120.214C87.5747 121.409 89.1769 122.237 91.017 122.486C93.8027 122.864 96.4711 121.831 98.2543 119.9Z",
    fill: "url(#paint7_linear_1099_57878)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.803 126.453C117.652 126.656 120.26 122.661 120.627 117.528C120.994 112.395 118.982 108.069 116.132 107.865C113.283 107.661 110.675 111.657 110.308 116.79C109.941 121.923 111.953 126.249 114.803 126.453Z",
    fill: "url(#paint8_radial_1099_57878)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.909 120.507C70.6336 121.366 74.0976 118.084 75.646 113.177C77.1945 108.269 76.241 103.594 73.5164 102.735C70.7918 101.876 67.3278 105.158 65.7793 110.066C64.2309 114.974 65.1844 119.648 67.909 120.507Z",
    fill: "url(#paint9_radial_1099_57878)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.157 44.3813C168.27 40.768 160.06 37.0006 153.101 40.4295C148.945 43.3457 142.454 46.8215 140.079 41.9062C139.76 41.2485 139.528 40.3669 139.35 39.3088C139.374 36.9614 143.554 30.6937 144.259 30.4078C152.515 22.2416 152.839 20.6808 161.087 17.4536C174.966 11.8576 195.33 14.9637 202.183 29.5879C203.328 33.4127 203.536 36.6417 203.017 39.2815C200.954 50.4242 186.799 51.8821 175.157 44.3813Z",
    fill: "url(#paint10_linear_1099_57878)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.157 44.3828C168.27 40.7695 160.06 37.002 153.101 40.431C148.945 43.3472 142.454 46.823 140.079 41.9077C147.555 34.3328 148.666 32.4723 157.471 29.0679C172.367 23.0499 193.64 25.5849 203.03 39.3644C200.954 50.4257 186.799 51.8837 175.157 44.3828Z",
    fill: "url(#paint11_linear_1099_57878)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1099_57878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.842 13.8021) scale(70.8851 70.8579)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3715,
    stopColor: "#85575F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3343"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1099_57878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.74 23.0527) rotate(88.8423) scale(36.2381 36.2494)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85575F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3343"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1099_57878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4583 63.3529) rotate(33.1124) scale(204.867 204.836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD7C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1099_57878",
    x1: 102.846,
    y1: 67.3347,
    x2: 191.016,
    y2: 175.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03E2D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03E2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1099_57878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3566 59.6834) rotate(40.4317) scale(71.6632 71.6588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC3BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F76050",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1099_57878",
    x1: 80.5826,
    y1: 180.686,
    x2: 79.0522,
    y2: 192.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A4645",
    stopOpacity: 0.688844
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA3528",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1099_57878",
    x1: 80.539,
    y1: 181.187,
    x2: 79.7111,
    y2: 187.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C404D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA3528",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1099_57878",
    x1: 85.9622,
    y1: 103.334,
    x2: 86.0592,
    y2: 103.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F75588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26161",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1099_57878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.452 117.148) rotate(4.08874) scale(7.53954 7.53938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#76203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1099_57878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.7 111.607) rotate(17.4985) scale(7.53929 7.53962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#76203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1099_57878",
    x1: 114.391,
    y1: 83.6091,
    x2: 193.439,
    y2: 19.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83CF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1099_57878",
    x1: 121.318,
    y1: 38.6554,
    x2: 205.144,
    y2: 37.0777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB830"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading2);
export default __webpack_public_path__ + "static/media/loading_2.21137ed1f663444f1a39dfb41bb9db87.svg";
export { ForwardRef as ReactComponent };